// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { FC, useState } from 'react';
import { UitkIcon } from 'uitk-react-icons';
import { UitkTertiaryButton } from 'uitk-react-button';
import { MenuItemConfig, UitkMenu, UitkMenuContainer, UitkMenuList, UitkMenuTrigger } from 'uitk-react-menu';
import { LanguageItemFragment } from 'graphql/__generated__/types';

interface LanguageSelectorDesktopProps {
  languageMenuItems: Array<MenuItemConfig>;
  currentLanguage: LanguageItemFragment;
  primaryIconName: string;
  secondaryIconName: string;
}

const LanguageSelectorDesktop: FC<LanguageSelectorDesktopProps> = (props) => {
  const { languageMenuItems, currentLanguage, primaryIconName, secondaryIconName } = props;
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <UitkMenu isOpen={isOpen} onTriggerClick={() => setIsOpen((prevState) => !prevState)}>
      <UitkMenuTrigger>
        <UitkTertiaryButton name="language-selection" data-testid="language-selection-button">
          <UitkIcon name={primaryIconName} />
          {currentLanguage.title}
          <UitkIcon name={secondaryIconName} />
        </UitkTertiaryButton>
      </UitkMenuTrigger>
      <UitkMenuContainer className="language-selection-menu">
        <UitkMenuList items={languageMenuItems} />
      </UitkMenuContainer>
    </UitkMenu>
  );
};

export default LanguageSelectorDesktop;
